/*!
 * devextreme-angular
 * Version: 26.1.5
 * Build date: Fri Sep 11 2026
 *
 * Copyright (c) 2012 - 2026 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/DevExtreme
 */

/* tslint:disable:max-line-length */


import {
    Component,
    OnInit,
    OnDestroy,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';





import {
    DxIntegrationModule,
    NestedOptionHost,
} from 'devextreme-angular/core';
import { NestedOption } from 'devextreme-angular/core';


@Component({
    selector: 'dxo-permissions',
    template: '',
    styles: [''],
    imports: [ DxIntegrationModule ],
    providers: [NestedOptionHost]
})
export class DxoPermissionsComponent extends NestedOption implements OnDestroy, OnInit  {
    @Input()
    get copy(): boolean {
        return this._getOption('copy');
    }
    set copy(value: boolean) {
        this._setOption('copy', value);
    }

    @Input()
    get create(): boolean {
        return this._getOption('create');
    }
    set create(value: boolean) {
        this._setOption('create', value);
    }

    @Input()
    get delete(): boolean {
        return this._getOption('delete');
    }
    set delete(value: boolean) {
        this._setOption('delete', value);
    }

    @Input()
    get download(): boolean {
        return this._getOption('download');
    }
    set download(value: boolean) {
        this._setOption('download', value);
    }

    @Input()
    get move(): boolean {
        return this._getOption('move');
    }
    set move(value: boolean) {
        this._setOption('move', value);
    }

    @Input()
    get rename(): boolean {
        return this._getOption('rename');
    }
    set rename(value: boolean) {
        this._setOption('rename', value);
    }

    @Input()
    get upload(): boolean {
        return this._getOption('upload');
    }
    set upload(value: boolean) {
        this._setOption('upload', value);
    }


    protected get _optionPath() {
        return 'permissions';
    }


    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }


    ngOnInit() {
        this._addRecreatedComponent();
    }

    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }


}

@NgModule({
  imports: [
    DxoPermissionsComponent
  ],
  exports: [
    DxoPermissionsComponent
  ],
})
export class DxoPermissionsModule { }
